import { render, staticRenderFns } from "./DialogEmailTwoFactor.vue?vue&type=template&id=1a2445d0&scoped=true"
import script from "./DialogEmailTwoFactor.vue?vue&type=script&lang=js"
export * from "./DialogEmailTwoFactor.vue?vue&type=script&lang=js"
import style0 from "./DialogEmailTwoFactor.vue?vue&type=style&index=0&id=1a2445d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2445d0",
  null
  
)

export default component.exports